<template>
  <div class="page-wrapper">
    <div class="content-wrapper" v-if="isDetail">
      <div class="content-left">
        <div class="service-info-wrapper">
          <div class="service-top">
            <div class="service-name-wrapper">
              <div class="service-name">{{ serviceInfo.service_name }}</div>
              <div
                class="service-label service-label1"
                v-for="(item, i) in serviceInfo.service_keyword_list"
                :key="i"
              >
                {{ item }}
              </div>
            </div>
            <div
              :class="[{ 'collected-btn': isVote == 1 }, 'collect-btn']"
              @click="voteFn($event)"
            >
              收藏
            </div>
          </div>
          <div class="service-descibe">{{ serviceInfo.content }}</div>
          <div class="service-charge-wrapper">
            <div class="sc-l">
              <div
                class="service-price"
                v-if="chargeInfo.price >= 0 && chargeInfo.price != -1"
              >
                <span class="price-charge">{{
                  chargeInfo.units == "人民币" ? "¥" : "HK$"
                }}</span>
                {{ chargeInfo.price }}
              </div>
              <!--商务无价格-->
              <div
                class="service-price business-tips"
                v-if="chargeInfo.business_model == 0 && chargeInfo.price == -1"
              >
                该产品支持个性化定制，请点击商务洽谈，我们会在2个工作日内联系您
              </div>
              <!--申请无价格-->
              <div
                class="service-price business-tips"
                v-if="chargeInfo.business_model == 2 && chargeInfo.price == -1"
              >
                请提交申请，审核通过后即可使用
              </div>
            </div>
            <div class="sc-split"></div>
            <div class="sc-r">
              <h-row class="sInfo-item">
                <h-col span="6">热度：</h-col>
                <h-col span="12">{{ serviceInfo.click_num }}</h-col>
              </h-row>
              <h-row class="sInfo-item">
                <h-col span="6">交付方式：</h-col>
                <h-col span="12">{{ serviceInfo.alternation_name }}</h-col>
              </h-row>
              <!-- <h-row class="sInfo-item">
                <h-col span="6">适用对象：</h-col>
                <h-col span="12">
                  <span>{{open_level}}</span>
                </h-col>
              </h-row> -->
            </div>
          </div>
          <div class="service-charge-list" v-if="!isIntegrated">
            <div class="charge-left" v-if="chargeList.length > 0">
              选择参数：
            </div>
            <div class="charge-right">
              <ul v-if="chargeList.length > 0">
                <li
                  :class="[
                    'charge-item',
                    { 'charge-item-active': i == clickChargeIndex }
                  ]"
                  v-for="(item, i) in chargeList"
                  :key="i"
                  @click="clickCharge(i)"
                >
                  {{ item.suite_name | filterName }}
                  <span
                    v-if="
                      item.suite_name &&
                        item.suite_name != '--' &&
                        serviceInfo.alternation_id != '7' &&
                        !serviceInfo.notInType
                    "
                    >：</span
                  >
                  <span v-if="serviceInfo.showEnv">
                    {{ item.environment_type == 2 ? "生产环境" : "测试环境" }}
                    /
                  </span>
                  <span class="peak">
                    <!--h5,ufx,订阅,saas不展示次数-->
                    <span
                      v-if="
                        serviceInfo.alternation_id != '12' &&
                          serviceInfo.alternation_id != '10' &&
                          serviceInfo.alternation_id != '7' &&
                          serviceInfo.alternation_id != '16' &&
                          serviceInfo.alternation_id != '2' &&
                          !serviceInfo.notInType
                      "
                      >{{ item.invoke_times }}{{ item.combo_type_name }} /</span
                    >
                    <span
                      v-if="
                        serviceInfo.alternation_id != '7' &&
                          !serviceInfo.notInType
                      "
                      >{{ item.used_length }}天</span
                    >
                    <span
                      v-if="
                        item.peak_value &&
                          item.peak_value != -1 &&
                          serviceInfo.showEnv
                      "
                      >，峰值：{{ item.peak_value }}次/秒</span
                    >
                  </span>
                  <span v-if="item.open_levels">/ 适用范围：{{caculateFitRange(item.open_levels)}}</span>
                </li>
              </ul>
            </div>
          </div>
          <div
            class="buy-btn"
            v-if="
              isIntegrated &&
                (cloud_resource_type === 'financial' ||
                  cloud_resource_type === 'public')
            "
            @click="
              getAliServiceLoginUrl(
                serviceInfo.openplat_cloud_product_dto.cloud_buy_url,
                'buyCloud'
              );
              setGio(chargeInfo&&chargeInfo.button_name||'立即购买')
            "
          >
            {{chargeInfo&&chargeInfo.button_name||'立即购买'}}
          </div>
          <div
            class="buy-btn"
            v-if="
              isIntegrated &&
                (cloud_resource_type === 'financial' ||
                  cloud_resource_type === 'public')
            "
            @click="
              getAliServiceLoginUrl(
                serviceInfo.openplat_cloud_product_dto.cloud_console_url,
                'console'
              );
              setGio('管理控制台')
            "
          >
            管理控制台
          </div>
          <div
            class="buy-btn"
            v-if="chargeInfo.business_model == 1 && !isIntegrated"
            @click="buyFn();setGio(chargeInfo.button_name||'立即购买')"
          >
          {{chargeInfo.button_name||'立即购买'}}
          </div>
          <div
            class="buy-btn"
            v-if="chargeInfo.business_model == 0 && !isIntegrated"
            @click="buyFn();setGio(chargeInfo.button_name||'商务洽谈')"
          >
          {{chargeInfo.button_name||'商务洽谈'}}
          </div>
          <div
            class="buy-btn"
            v-if="chargeInfo.business_model == 2 && !isIntegrated"
            @click="buyFn();setGio(chargeInfo.button_name||'申请使用')"
          >
          {{chargeInfo.button_name||'申请使用'}}

          </div>
          <div class="buy-btn" v-if="product_doc_id" @click="jumpToProductDoc();setGio('产品文档')">
            产品文档
          </div>
        </div>
        <div class="service-info-bottom">
          <div class="service-nav-wrapper">
            <div
              :class="[
                'service-nav-item',
                { 'service-nav-active': tabClick == 1 }
              ]"
              @click="tabClickFn(1);setGio('产品详情')"
            >
              产品详情
            </div>
            <div
              :class="[
                'service-nav-item',
                { 'service-nav-active': tabClick == 2 }
              ]"
              @click="tabClickFn(2);setGio('API文档')"
              v-if="showApiTab"
            >
              API文档
            </div>
            <!-- <div
              :class="[
                'service-nav-item',
                { 'service-nav-active': tabClick == 3 }
              ]"
              @click="tabClickFn(3);setGio('评论详情')"
              v-if="commentShow"
            >
              评论详情
            </div> -->
          </div>
          <div class="sb-content-wrapper">
            <div
              class="sb-content-1"
              v-html="serviceInfo.service_content"
              v-if="tabClick == 1 && serviceInfo.service_content"
            ></div>
            <!-- 添加联系方式信息 extra_info -->
            <h-button
              v-if="tabClick == 1 && serviceInfo.extra_info"
              @click="handleExtraInfoMsgBoxClick"
              type="info"
            >
              更多服务信息</h-button
            >
            <h-msg-box
              v-model="modalExtraInfoMsgBox"
              class="vertical-center-modal"
              :top="0"
              :allowCopy="true"
              :closable="false"
              :maxHeight="500"
            >
              <div
                slot="header"
                style="display:flex;align-items:center;justify-content: center"
              >
                <img
                  src="../../assets/icons/extraInfoHeaderIcon.png"
                  alt
                  style="width:24px;height:24px;"
                />
                <span class="msg-extra-header-span">服务信息</span>
              </div>
              <div
                v-html="serviceInfo.extra_info"
                class="extra-info-styles"
              ></div>
              <div slot="footer" class="msg-extra-footer">
                <h-button type="info" @click="modalExtraInfoMsgBox = false"
                  >我已知悉</h-button
                >
              </div>
            </h-msg-box>
            <div
              class="sb-content-1"
              v-if="tabClick == 1 && !serviceInfo.service_content"
            >
              <div class="no-service-info">本产品暂无详情...</div>
            </div>
            <div class="sb-content-2" v-if="tabClick == 2">
              <api-doc
                :serviceId="service_id"
                :serviceName="serviceInfo.service_name"
              ></api-doc>
              <!-- <iframe :src="apiUrl" frameborder="no" border="0" height="1000" width="880"></iframe> -->
            </div>
            <!-- <div class="sb-content-3" v-show="tabClick == 3">
              <evaluate
                :serviceId="service_id"
                :userInfo="user"
                @showEvaluate="updateShow"
              ></evaluate>
            </div> -->
          </div>
        </div>
      </div>
      <div class="content-right">
        <div class="provider-info">
          <h-row class="sInfo-item">
            <h-col span="6">服务商：</h-col>
            <h-col class="sinfo-right theme-color">
              <a
                v-if="companyInfo && companyInfo.store_id"
                :href="
                  '/shop.html?store_id=' +
                    companyInfo.store_id +
                    '&company_id=' +
                    companyInfo.company_id
                "
                >{{ companyInfo.company_name }}</a
              >
              <span v-if="companyInfo && !companyInfo.store_id">{{
                companyInfo.company_name
              }}</span>
            </h-col>
          </h-row>
          <h-row class="sInfo-item">
            <h-col span="6">联系我们：</h-col>
            <!-- <h-col class="sinfo-right theme-color cursor-pointer">
              <a
                class="sub-btn"
                :href="customerServiceUrl"
                target="_blank"
                @click.stop="setGio('在线客服');gioTrackEvent('OP_onlineServiceClick')"
              >
                在线客服
              </a>
            </h-col> -->
            <h-col class="sinfo-right theme-color cursor-pointer other-table">
              <div
                class="sub-btn"
                @click="showOtherChannel = !showOtherChannel;setGio('联系方式');"
              >
                联系方式
              </div>
              <div class="channels" v-show="showOtherChannel">
                <div
                  class="channel-item"
                  v-for="item in otherChannel"
                  :key="item.label"
                >
                  <span class="channel-label">{{ item.label }} :&nbsp;</span>
                  <span class="channel-value" v-if="item.label !== '邮箱'">{{
                    item.value
                  }}</span>
                  <a v-else class="email-text" :href="'mailto:' + item.value">{{
                    item.value
                  }}</a>
                </div>
              </div>
            </h-col>
          </h-row>
          <h-row class="sInfo-item">
            <h-col span="6">问题处理：</h-col>
            <h-col class="sinfo-right">
              <div class="sub-btn" @click="submitWork();setGio('提交工单');">提交工单</div>
            </h-col>
          </h-row>
        </div>
        <div class="announcement-wrapper">
          <div class="announcement-title">相关公告</div>
          <ul>
            <li
              class="announcement-item"
              v-for="(item, i) in newsList"
              :key="i"
              @click="setGio('相关公告')"
            >
              <a
                :href="
                  `/openplat-doc/informationDetail/detail/` + item.serial_num
                "

              >
                <div class="a-title">{{ item.blog_title }}</div>
                <div class="acreate-item">{{ item.update_time }}</div>
              </a>
            </li>
          </ul>
        </div>
        <div class="service-realted">
          <div class="service-title">相关服务</div>
          <ul>
            <li
              class="realtedService-item"
              v-for="(item, i) in serviceList"
              :key="i"
              @click="setGio('相关服务');setClickGio(i,item)"
            >
              <router-link :to="'/service/serviceDetail/' + item.service_id">
                <div class="rs-name">{{ item.service_name }}</div>
                <div class="rs-label">
                  <div
                    class="rs-label-item"
                    v-for="(item1, j) in serviceList[i].service_keyword_list"
                    :key="j"
                  >
                    {{ item1 }}
                  </div>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <h-msg-box
      title="补充信息填写"
      v-model="modalExtra"
      class-name="vertical-center-modal"
      :top="100"
      width="800"
      height="350"
      cols="2"
    >
      <create-form
        :itemList="extraList"
        :formItem="formItemE"
        v-if="extraList.length > 0"
        ref="extra"
      ></create-form>
      <p slot="footer" style="display: flex; justify-content: center">
        <h-button type="primary" @click="extraOk">确定</h-button>
        <h-button type="ghost" @click="extraCancel">取消</h-button>
      </p>
    </h-msg-box>
    <!--填写合同拓展信息-->
    <router-view />
    <create-work-order ref="workOrder"></create-work-order>
    <IndexFooter />
    <buyCheck ref="buyCheckRef"/>
  </div>
</template>
<script>
import { getServieDetailApiGroups } from "@/api/frontDoc/api";
import {
  isVote,
  vote,
  unVote,
  detail,
  getServiceOpenLevel,
  queryDictItem,
  getServiceCompany,
  queryBlogListByService,
  queryServiceList,
  saveServiceContractExtAttr,
  getChargeInfo,
  getchargeUserCanBuyNum,
  isActivity,
  getAliServiceLogin
} from "@/api/service.js";
import store from "@/store";
import ApiDoc from "@/views/frontViews/components/apiDoc";
// import Evaluate from "@/views/frontViews/components/evaluate";//评价详情
import CreateForm from "@/views/frontViews/components/createForm";
import CreateWorkOrder from "@/views/frontViews/components/createWorkOrder";
import _ from "lodash";
import { mapGetters } from "vuex";
import IndexFooter from "@/components/index/indexFooter";
import buyCheck from './components/buyCheck.vue';

function testMobile() {
  let check = false;
  (function(a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}
export default {
  name: "serviceDetail",
  data() {
    return {
      open_level:"",//适用对象
      // open_level_list:[],
      showApiTab: false,
      modalExtraInfoMsgBox: false, //更多服务信息弹窗控制布尔值
      showOtherChannel: false, // 其他联系方式展示
      otherChannel: [], // 其他联系方式
      isIntegrated: false,
      cloud_resource_type: "",
      service_id: this.$route.params.id,
      serviceInfo: {},
      chargeInfo: {},
      clickChargeIndex: 0,
      chargeList: [],
      tabClick: 1,
      login: true,
      isVote: -1,
      newsList: [],
      companyInfo: {},
      commentShow: true,
      serviceList: [],
      // serviceUrl: window.LOCAL_CONFIG.serviceUrl,
      extraList: [],
      modalExtra: false,
      formItemE: {},
      alternationList: [
        { alternation_name: "API", alternation_id: "1" },
        { alternation_name: "H5", alternation_id: "2" },
        { alternation_name: "API-SAAS", alternation_id: "3" },
        { alternation_name: "SDK", alternation_id: "11" },
        { alternation_name: "培训", alternation_id: "8" },
        { alternation_name: "UFX", alternation_id: "12" },
        { alternation_name: "账号", alternation_id: "4" },
        { alternation_name: "下载", alternation_id: "5" },
        { alternation_name: "人力", alternation_id: "6" },
        { alternation_name: "其他", alternation_id: "7" },
        { alternation_name: "订阅", alternation_id: "10" },
        { alternation_name: "SAAS", alternation_id: "16" }
      ],
      loading: false,
      remoteLabel: "",
      apiUrl: "",
      activityStart: false,
      isDetail:
        this.$route.path.indexOf("orderPaySuccess") == -1 &&
        this.$route.path.indexOf("payment") == -1 &&
        this.$route.path.indexOf("apply") == -1 &&
        this.$route.path.indexOf("confirmOrder") == -1
          ? true
          : false,
      product_doc_id: "",
      customerServiceUrl:
        "/cschat/index.html?i=PCYOW2CN&s=SCE00313934&cinfo=&key="
    };
  },
  filters: {
    filterName: function(value) {
      if (value == "--") {
        return "";
      } else {
        return value;
      }
    }
  },
  components: {
    // Evaluate,
    CreateForm,
    CreateWorkOrder,
    IndexFooter,
    ApiDoc,
    buyCheck
  },
  computed: {
    ...mapGetters(["user", "uPlusUser"])
  },
  watch: {
    $route(to, from) {
      // isInMobile(this.$route.params.id);
      this.service_id = this.$route.params.id;
      this.isDetail =
      this.$route.path.indexOf("orderPaySuccess") == -1 &&
        this.$route.path.indexOf("payment") == -1 &&
        this.$route.path.indexOf("apply") == -1 &&
        this.$route.path.indexOf("confirmOrder") == -1
          ? true
          : false;
      if (this.isDetail) {
        this.initalPage();
        this.tabClick = 1;
        this.clickChargeIndex = 0;
      }
    },
    uPlusUser: {
      handler(val) {
        if (val) {
          this.customerServiceUrl = `/cschat/index.html?i=PCYOW2CN&s=SCE00313934&cinfo=${this.uPlusUser.yunCustomerServiceParamers}&key=${this.uPlusUser.yunCustomerServiceKey}`;
        }
      },
      deep: true
    }
  },
  beforeCreate() {
    // isInMobile(this.$route.params.id);
  },
  created() {
    this.service_id = this.$route.params.id;
    this.getDict()
  },
  mounted() {
    //this.userInfo = store.getters.user;
    if (this.isDetail) {
      this.initalPage();
    }
  },
  methods: {

    getDict() {
      queryDictItem("open_level")
        .then(res => {
          this.open_level_list = res;
        })
        .catch(error => {});
    },
    setClickGio(index,item) {
      this.gioTrackEvent("UMod_clickModule", {
        serialNumber_var: index + 1,
        clickArea_var: "相关服务",
        moduleId_var:item.service_id,
        moduleName_var: item.service_name,
      });
    },
    setGio(name,collectionValue_var) {
      let moduleParm_var=""
      let active = document.getElementsByClassName('charge-item-active')
      if(active&&active.length){
        moduleParm_var = active[0].innerText
      }
      try {
        this.gioTrackEvent("UMod_clickInDetailPage", {
          clickButtonName_var:name,
          moduleId_var: this.service_id,
          moduleName_var: this.serviceInfo.service_name,
          moduleParm_var:moduleParm_var,
          collectionValue_var:collectionValue_var
        });
      } catch (e) {
        console.log(e);
      }
    },
    jumpToProductDoc() {
      location.href =
        "/openplat-doc/ProFDocDetail?proId=" + this.product_doc_id;
    },
    // 处理更多服务信息按钮点击
    handleExtraInfoMsgBoxClick() {
      this.modalExtraInfoMsgBox = true;
      this.gioTrackEvent("OP_extraInfoClick", {
        // hsUserId_var: this.user.hsid || "-",
        productName_var: this.serviceInfo.service_name || "-"
        // deviceType_var: getDeviceType()
      });
    },
    async getAliServiceLoginUrl(login, id) {
      let that = this;
      const res = await getAliServiceLogin({
        service_id: this.serviceInfo.service_id,
        login_url: login,
        cloud_resource_type: this.serviceInfo.openplat_cloud_product_dto
          .cloud_resource_type
      });
      if(res.error_code != "0"){
        this.gioTrackEvent("U_errorReporting", {
          moduleId_var:this.serviceInfo.service_id,
          errorType_var: res.error_code,
          errorContent_var:res.error_info
        });
      }
      console.log(res.error_code);
      if (res.error_code == "130031") {
        this.$hMsgBox.confirm({
          content:
            "<p>购买该服务需要消费云资源额度，您的云资源额度目前为0，请先购买云资源包！</p>",
          okText: "去充值",
          onOk() {
            window.location.href = res.data.resource_bundle_address;
          }
        });
      } else if (res.error_code == "100002") {
        this.$hMsgBox.confirm({
          content: "<p>您还没有登录，请点击前往登录</p>",
          onOk: () => {
            that.$goLoginUrl();
          }
        });
      } else if (res.error_code == "0") {
        localStorage.setItem("login_url", res.data.login_url);
        window.open("/openplat-front/service/" + id, "_blank");
      } else {
        this.$hMessage.info(res.error_info);
      }
    },
    submitWork() {
      this.gioTrackEvent("OP_issueTicketSubmit");
      window.location.href =
        window.origin +
        window.LOCAL_CONFIG.PROJECT_NAME +
        "/workOrder/submitWorkOrder";
    },
    hanlderVal(val) {
      return val == 0 || val == -1 ? "不限" : val;
    },
    initalPage() {
      this.getProvicerInfo();
      this.getServiceAnouncement();
      this.getApiDocUrl();
      // this.getShowEvaluate();
      this.getServiceOpenLevel();//适用范围
      detail(this.service_id)
        .then(res => {
          this.serviceInfo = res;
          this.product_doc_id = this.serviceInfo.product_doc_id
            ? this.serviceInfo.product_doc_id.trim()
            : "";
          //如果交付方式为API-SASS/SDK/API，展示环境
          if (
            this.serviceInfo.alternation_id == "1" ||
            this.serviceInfo.alternation_id == "3" ||
            this.serviceInfo.alternation_id == "11"
          ) {
            this.serviceInfo.showEnv = true;
          } else {
            this.serviceInfo.showEnv = false;
          }
          //其他交付类型不展示次数、天数字段
          let that = this;
          let findList = this.alternationList.find(
            element => element.alternation_id == that.serviceInfo.alternation_id
          );
          if (findList && findList.alternation_id) {
            this.serviceInfo.notInType = false;
          } else {
            this.serviceInfo.notInType = true;
          }
          //其他交付类型不展示次数、天数字段
          let list = res.service_charge_list || [],
            listNew = [];
          if (
            this.serviceInfo.openplat_cloud_product_dto.integrated_state === "Y"
          )
            this.isIntegrated = true;
          else this.isIntegrated = false;
          if (
            this.serviceInfo.openplat_cloud_product_dto.cloud_resource_type ===
            "financial"
          )
            this.cloud_resource_type = "financial";
          else if (
            this.serviceInfo.openplat_cloud_product_dto.cloud_resource_type ===
            "public"
          )
            this.cloud_resource_type = "public";
          else if (
            this.serviceInfo.openplat_cloud_product_dto.cloud_resource_type ===
            "qianCloud"
          )
            this.cloud_resource_type = "qianCloud";
          else this.cloud_resource_type = "";

          if (list && list.length > 0) {
            for (let i = 0, l = list.length; i < l; i++) {
              list[i].invoke_times = this.hanlderVal(list[i].invoke_times);
              list[i].used_length = this.hanlderVal(list[i].used_length);
              let comboType = "",
                aid = this.serviceInfo.alternation_id;
              let val =
                aid == "6"
                  ? "人数"
                  : aid == "8"
                  ? "人次"
                  : aid == "4"
                  ? "账号数"
                  : "次数";
              comboType = val;
              list[i].combo_type_name = comboType;
              if (
                this.serviceInfo.alternation_name != "API" &&
                this.serviceInfo.alternation_name != "SDK" &&
                this.serviceInfo.alternation_name != "API-SAAS"
              ) {
                if (list[i].environment_type == 2) {
                  listNew.push(list[i]);
                }
              }
            }
          }

          this.chargeList =
            this.serviceInfo.alternation_name != "API" &&
            this.serviceInfo.alternation_name != "SDK" &&
            this.serviceInfo.alternation_name != "API-SAAS"
              ? listNew
              : list;
          this.chargeInfo =
            this.chargeList.length > 0 ? this.chargeList[0] : {};
          this.getServiceList();
          // 服务详情埋点
          this.gioTrackEvent("OP_goodsDetailBrowse", {
            productId_var: res.service_id,
            productName_var: res.service_name || "-",
            firstCategoryName_var: res.classify_list[0].classify_name || "-",
            secondCategoryName_var:
              res.classify_list[0].child_classify_name || "-",
            productDeliveryMethod_var: res.alternation_name,
            suitableIndustry_var: res.service_indestry_name //适用行业
          });
        })
        .catch(error => {});
      if (store.getters.user.hsid) {
        this.getVoteInfo();
      } else {
        this.isVote = 0;
      }
    },
    getServiceOpenLevel(){
      getServiceOpenLevel(this.service_id)
        .then(res => {
          this.open_level = res.open_level
        })
        .catch(error => {});
    },
    // getShowEvaluate() {
    //   getSysAttribute()
    //     .then(res => {
    //       if (res.attribute_value == 1) {
    //         this.commentShow = true;
    //       } else {
    //         this.commentShow = false;
    //       }
    //     })
    //     .catch(error => {});
    // },
    getServiceList() {
      // ;
      queryServiceList(
        this.serviceInfo.classify_list[0].classify_id,
        this.service_id
      )
        .then(res => {
          this.serviceList = res.list.slice(0, 3);
        })
        .catch(error => {});
    },
    // updateShow() {
    //   this.commentShow = false;
    // },
    getServiceAnouncement() {
      queryBlogListByService(this.service_id)
        .then(res => {
          this.newsList = res.slice(0, 4);
        })
        .catch(error => {});
    },
    getProvicerInfo() {
      getServiceCompany(this.service_id)
        .then(res => {
          if (res) {
            this.companyInfo = res;
          } else {
            this.companyInfo = {};
          }
          // this.companyInfo.customer_phone =
          //   res && res.customer_phone
          //     ? res.customer_phone
          //     : window.LOCAL_CONFIG.GTN_TEL;
          this.companyInfo.customer_email =
            res && res.customer_email
              ? res.customer_email
              : window.LOCAL_CONFIG.GTN_EMAIL;
          this.initOtherChannel();
        })
        .catch(error => {});
    },
    // 设置其他联系方式，将电话和邮箱聚合到otherChannel中
    initOtherChannel() {
      this.otherChannel = [];
      // if (this.companyInfo.customer_phone) {
      //   this.otherChannel.push({
      //     label: "电话",
      //     value: this.companyInfo.customer_phone
      //   });
      // }
      if (this.companyInfo.customer_email) {
        this.otherChannel.push({
          label: "邮箱",
          value: this.companyInfo.customer_email
        });
      }
    },
    getVoteInfo() {
      isVote(this.service_id)
        .then(res => {
          if (res) {
            this.isVote = 1;
          } else {
            this.isVote = 0;
          }
        })
        .catch(error => {});
    },
    getApiDocUrl() {
      getServieDetailApiGroups({
        service_id: this.service_id
      }).then(res => {
        if (res.error_no == 0) {
          if (
            res.service_infos[0] &&
            res.service_infos[0].api_infos &&
            res.service_infos[0].api_infos.length
          ) {
            this.showApiTab = true;
          } else {
            this.showApiTab = false;
          }
        }
      });
    },
    /***收藏***/
    voteFn(event) {

      if (this.isVote == 1) {
        this.setGio('取消收藏',-1)
        unVote(this.service_id)
          .then(res => {
            if (res === null) {
              this.isVote = 0;
            }
            //this.$hMessage.success('您已成功收藏！');
          })
          .catch(error => {});
      } else {
        this.setGio('收藏',1)
        //doVote
        vote(this.service_id)
          .then(res => {
            if (res === null) {
              this.isVote = 1;
            }
            //this.$hMessage.success('您已取消收藏！');
          })
          .catch(error => {});
      }
    },
    ok() {
      //this.modalLogin = false;
      this.$goLoginUrl();
    },
    cancel() {
      //this.modalLogin = false;
    },
    extraOk() {
      let dataList = [];
      for (let key in this.$refs.extra.formItem2) {
        let itemOne = {};
        itemOne.contract_ext_attr_no = key;
        itemOne.contract_ext_attr_value = String(
          this.$refs.extra.formItem2[key]
        );
        dataList.push(itemOne);
      }
      this.$refs.extra.$refs.formCreate.validate(valid => {
        if (valid) {
          saveServiceContractExtAttr(this.service_id, dataList)
            .then(res => {
              //this.newsList = res.slice(0,4);
              if (res === null) {
                this.$hMessage.success("提交成功，即将前往订单页");
                setTimeout(() => {
                  this.$router.push({
                    path:
                      "/service/serviceDetail/" +
                      this.service_id +
                      "/confirmOrder/" +
                      this.chargeInfo.serial_no,
                    query: {
                      apply_type: this.chargeInfo.environment_type
                    }
                  });
                }, 2000);
              }
            })
            .catch(error => {});
        }
      });
    },
    extraCancel() {
      this.modalExtra = false;
    },
    buyFn() {
      let that = this;
      if (!store.getters.user.hsid) {
        //this.modalLogin = true;
        //return;
      }
      if (this.chargeInfo.inventory == 0) {
        this.gioTrackEvent("U_errorReporting", {
          moduleId_var:this.chargeInfo.service_id,
          errorType_var: '',
          errorContent_var:"当前库存不足，看看其他套餐吧"
        });
        this.$hMessage.warning("当前库存不足，看看其他套餐吧");
        return;
      }
      if (that.chargeInfo.buy_cap == -1) {
        that.buyAcitivty();
      } else {
        // ;
        getchargeUserCanBuyNum(this.chargeInfo.serial_no).then(res => {
          //  ;
          //判断实际购买上限，也可后台直接返回
          if (
            that.chargeInfo.buy_cap != -1 &&
            that.buyNum > that.chargeInfo.buy_cap - res
          ) {
            let canBuyNum = that.clickSuitInfo.buy_cap - res;
            this.$hMessage.warning(
              "每个用户限购" +
                that.chargeInfo.buy_cap +
                "份" +
                "您已购买" +
                response.data.data +
                "份"
            );
            this.gioTrackEvent("U_errorReporting", {
              moduleId_var:this.chargeInfo.service_id,
              errorType_var: '',
              errorContent_var:"每个用户限购" +
                that.chargeInfo.buy_cap +
                "份" +
                "您已购买" +
                response.data.data +
                "份"
            });
            return false;
          } else {
            that.buyAcitivty();
          }
        });
      }
    },
    buyAcitivty() {
      getChargeInfo(this.chargeInfo.serial_no)
        .then(res => {
          let data = res;
          if (data.is_limit_activity == "1") {
            let inventory_s = data.inventory;
            //库存查询
            isActivity().then(res => {
              if (res == false) {
                this.gioTrackEvent("U_errorReporting", {
                  moduleId_var:this.chargeInfo.service_id,
                  errorType_var: '',
                  errorContent_var:"每天10点准时开抢！"});
                this.$hMessage.warning("每天10点准时开抢！");
              } else if (inventory_s == 0 && res == true) {
                //common.tips("已抢完！",2000);
                this.gioTrackEvent("U_errorReporting", {
                  moduleId_var:this.chargeInfo.service_id,
                  errorType_var: '',
                  errorContent_var:"已抢完！"});
                this.$hMessage.warning("已抢完！");
              } else {
                this.buy();
              }
            });
          } else {
            this.buy();
          }
        })
        .catch(err => {});
    },
    buy() {
      this.$refs.buyCheckRef.initCheck(this.chargeInfo)
    },
    intailExtraValue() {
      this.$refs.extra.$refs.formCreate.resetFields();
      this.formItemE = Object.assign({}, {});
      for (let item of this.extraList) {
        let list1, listRes;
        if (item.input_box_type == 3) {
          if (item.default_value) {
            list1 = item.default_value.replace(/，/g, ",");
            listRes = list1.split(",");
          }
          this.formItemE[item.contract_ext_attr_no] = item.default_value
            ? listRes
            : [];
        } else if (item.input_box_type == 6) {
          this.$refs.extra.$refs[
            "upload" + item.contract_ext_attr_no
          ][0].clearFiles();
          this.formItemE[item.contract_ext_attr_no] = item.default_value
            ? item.default_value
            : "";
        } else {
          this.formItemE[item.contract_ext_attr_no] = item.default_value
            ? item.default_value
            : "";
        }
      }
    },
    goApply() {},
    clickCharge(index) {
      this.clickChargeIndex = index;
      this.chargeInfo = this.chargeList[index];
    },
    tabClickFn(index) {
      this.tabClick = index;
    },
    // 计算适用范围【即适用用户】
    caculateFitRange(open_levels) {
      // 使用范围显示有顺序
      const levelList = ['0', '2', '4', '3', '1']
      const openLevelMap = {
        0: '全部用户',
        1: '个人',
        2: '企业',
        3: '恒生员工',
        4: '企业员工'
      }
      let openLevels = ''
      if (!open_levels) {
        return openLevels
      }
      const arr = open_levels.split(',')
      const filerList = levelList.filter(i => arr.includes(i))
      const labelList = []
      filerList.forEach(item => {
        labelList.push(openLevelMap[item])
      })
      openLevels = labelList.join('、')
      return openLevels
    }
  }
};
</script>

<style lang="scss" scoped>
$colorStyle: #3b6bfa;

.h-breadcrumb > span:last-child {
  color: $colorStyle;
}

.cursor-pointer {
  cursor: pointer;
}

.page-wrapper {
  min-height: calc(100vh - 60px);
}

.hs-topbar {
  /**max-width:1200px;**/
  margin: 0 auto;
  background: #fff;
}

.hs-topbar-header {
  height: 70px;
  line-height: 70px;
  width: 1180px;
  margin: 0 auto;
  display: table;
  word-spacing: -1em;
}

.header-item {
  display: inline-block;
  cursor: pointer;
}

.logo-wrapper {
  height: 100%;
}

.logo-wrapper img {
  width: 165px;
  height: 36px;
  vertical-align: middle;
}

.nav-text-split {
  padding: 0 14px 0 10px;
  /**height:14px;**/
}

.nav-text {
  color: #333;
  font-size: 16px;
}

.search-wrapper {
  margin-left: 61px;
  height: 35px;
}

.search-wrapper input {
  width: 380px;
  height: 100%;
  border: 2px solid $colorStyle;
  text-indent: 37px;
}

input:focus {
  outline-offset: 0;
  outline: none;
}

.search-btn {
  background: $colorStyle;
  width: 72px;
  height: 35px;
  line-height: 35px;
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0.33px;
  text-align: center;
}

.h-l-wrapper {
  float: left;
}

.h-r-wrapper {
  float: right;
}

.h-r-wrapper .function-text {
  height: 70px;
  line-height: 70px;
  font-size: 14px;
  color: #333333;
  letter-spacing: 0.33px;
  margin-right: 35px;
}

.h-r-wrapper .function-btn {
  background: $colorStyle;
  width: 120px;
  height: 35px;
  line-height: 35px;
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0.33px;
  text-align: center;
}

.nav-wrapper {
  width: 1180px;
  margin: 0 auto;
  display: flex;
}

.nav-wrapper .nav-item {
  font-size: 14px;
  color: #333333;
  letter-spacing: 0.33px;
  margin: 13px 61px 13px 0;
}

.content-wrapper {
  width: 1200px;
  margin: 0 auto;
  padding-top: 16px;

  //padding-top:12px;
  .breadcrumb-wrapper {
    margin-bottom: 11px;
  }
}

.content-wrapper .service-info-wrapper {
  background: #ffffff;
  padding: 13px 20px 20px 20px;
  margin: 0 0 16px 0;
  width: 909px;
}

.service-info-wrapper .service-top {
  //height:30px;
  margin-top: 12px;
  position: relative;

  .service-name-wrapper {
    width: 760px;
  }
}

.service-info-wrapper .service-name {
  font-size: 20px;
  color: #000000;
  letter-spacing: 0.47px;
  font-weight: bold;
  display: inline-block;
  vertical-align: middle;
  max-width: 760px;
  padding-right: 12px;
}

.service-info-wrapper .service-label-wrapper {
  display: inline-block;
  vertical-align: middle;
  max-width: 350px;
  overflow: hidden;
  height: 20px;
  line-height: 20px;
  margin-bottom: 1px;
}

.service-info-wrapper .service-label-wrapper li {
  display: inline-block;
  margin-right: 8px;
  float: left;
}

.service-info-wrapper .collect-btn {
  height: 30px;
  line-height: 30px;
  width: 90px;
  border: 1px solid $colorStyle;
  color: $colorStyle;
  background: url(../../assets/no-collect.png) no-repeat 19px 6px;
  text-indent: 15px;
  text-align: center;
  cursor: pointer;
  float: right;
  vertical-align: middle;
  position: absolute;
  right: 0;
  top: 0;

  &:hover {
    background: $colorStyle url(../../assets/collected.png) no-repeat 19px 6px;
    color: #fff;
  }
}

.service-info-wrapper .collected-btn {
  background: $colorStyle url(../../assets/collected.png) no-repeat 19px 6px;
  color: #fff;
}

.service-info-wrapper .service-descibe {
  font-size: 14px;
  color: #606266;
  letter-spacing: 0.33px;
  line-height: 22px;
  margin: 16px 0 20px 0;
}

.service-info-wrapper .service-charge-wrapper {
  width: 869px;
  height: 100px;
  background: url(../../assets/service-infoBg.png) no-repeat;
  margin: 0 auto;
  display: flex;
  align-items: center;
  position: relative;
}

.service-info-wrapper .sc-l {
  width: 554px;
}

.service-info-wrapper .service-price {
  font-size: 24px;
  color: #ff595e;
  letter-spacing: 0;
  margin-left: 20px;
}

.service-info-wrapper .business-tips {
  font-size: 16px;
  color: #ff595e;
  letter-spacing: 0;
  margin-left: 20px;
}

.service-info-wrapper .service-price .price-charge {
  margin-right: 5px;
  font-size: 14px;
}

.service-info-wrapper .sc-split {
  position: absolute;
  border: 1px solid #c6e2ff;
  left: 555px;
  height: 72px;
  width: 2px;
  background: #c6e2ff;
}

.service-info-wrapper .sc-r {
  //flex:3.3;
  width: 300px;
  font-size: 12px;
  color: #3a3b3d;
  letter-spacing: 0;
  margin-left: 15px;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.service-info-wrapper .sc-r .sInfo-item {
  margin-bottom: 5px;
}

.other-table {
  position: relative;

  .channels {
    position: absolute;
    top: 0;
    right: 87px;
    width: 150px;
    color: #666;
    padding: 8px 3px;
    box-shadow: 0 0 0 1px #c6e2ff;
    background: #fff;
    z-index: 1;
    cursor: default;
  }

  .channel-item {
    word-break: break-all;
  }
}

.service-info-wrapper .sc-r .sInfo-item:last-child {
  margin-bottom: 0;
}

.service-charge-list {
  margin: 20px 0 40px 0;

  .charge-right {
    display: inline-block;
  }

  .charge-left {
    display: inline-block;
    width: 76px;
    margin-right: 5px;
    vertical-align: top;
    font-size: 14px;
    color: #3a3b3d;
    letter-spacing: 0.33px;
    line-height: 22px;
    margin-top: 6px;
  }

  .charge-item {
    min-height: 36px;
    background: #ffffff;
    border: 1px solid #dcdfe6;
    font-size: 14px;
    color: #606266;
    letter-spacing: 0;
    line-height: 14px;
    margin-bottom: 10px;
    padding: 10px 20px;
    background: url(../../assets/radio_unchecked.png) 18px 10px no-repeat;
    text-indent: 24px;
    cursor: pointer;
  }

  .charge-item-active {
    border: 1px solid $colorStyle;
    color: $colorStyle;
    background: url(../../assets/radio_checked.png) 18px 10px no-repeat;
    cursor: pointer;
  }
}

.content-left {
  display: inline-block;
  vertical-align: top;
  margin-bottom: 16px;

  .service-info-bottom {
    width: 909px;
    background: #fff;
    padding: 0 20px 20px 20px;

    .service-nav-wrapper {
      //padding:18px 0 17px 0;
      .service-nav-item {
        font-size: 14px;
        color: #333333;
        letter-spacing: 0;
        line-height: 14px;
        display: inline-block;
        padding: 18px 0 17px 0;
        margin-right: 41px;
        cursor: pointer;
      }

      .service-nav-active {
        color: $colorStyle;
        border-bottom: 2px solid $colorStyle;
      }
    }

    .sb-content-wrapper {
      margin: 20px 0;

      .no-service-info {
        padding-top: 10px;
        min-height: 350px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      /deep/ .h-btn-info {
        margin-top: 20px;
        background-color: #3060ff;
      }
    }
  }
}

.content-right {
  display: inline-block;
  vertical-align: top;
  margin-left: 10px;

  .provider-info {
    width: 277px;
    padding: 15px;
    background: #fff;

    .sInfo-item {
      margin-bottom: 15px;
      font-size: 12px;

      .sinfo-right {
        margin-left: 12px;
        display: inline-block;

        .email-text {
          font-size: 12px;
          color: #333333;
          letter-spacing: 0.28px;

          &:hover {
            color: #0ae;
          }
        }

        a {
          color: $colorStyle;

          &:hover {
            color: $colorStyle;
          }
        }

        //text-decoration: underline;
        .sub-btn {
          display: block;
          padding: 0 2px;
          height: 18px;
          line-height: 18px;
          border: 1px solid $colorStyle;
          font-size: 12px;
          color: $colorStyle;
          letter-spacing: 0.28px;
          text-align: center;
          cursor: pointer;

          &:hover {
            background: $colorStyle;
            color: #fff;
          }
        }
      }
    }

    .theme-color {
      font-size: 12px;
      color: $colorStyle;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .announcement-wrapper {
    width: 277px;
    background: #fff;
    margin: 16px 0 16px 0;
    padding: 15px 0;

    .announcement-title {
      font-size: 14px;
      color: #333333;
      letter-spacing: 0;
      font-weight: bold;
      // padding-bottom: 15px;
      padding: 0 15px 15px;
    }

    .announcement-item {
      // margin-bottom: 15px;
      padding: 7px 15px;

      .a-title {
        font-size: 14px;
        color: #333333;
        letter-spacing: -0.2px;
        line-height: 20px;
        margin-bottom: 7px;
        width: 247px;
        overflow: hidden;
        word-break: break-all;
      }

      .acreate-item {
        font-size: 12px;
        color: #999999;
        letter-spacing: 0;
        line-height: 17px;
      }

      &:hover {
        box-shadow: 0 0 5px 2px rgba(223, 232, 241, 0.43);
        background: #fff;
      }
    }
  }

  .service-realted {
    width: 277px;
    background: #fff;
    padding: 15px 15px;
    margin-bottom: 16px;
    .service-title {
      font-size: 14px;
      color: #333333;
      letter-spacing: 0;
      font-weight: bold;
      padding-bottom: 15px;
    }

    .realtedService-item {
      width: 250px;
      height: 70px;
      margin: 0 auto 15px auto;
      padding: 10px;
      // opacity: 0.5;
      background-image: linear-gradient(
        270deg,
        rgba(222, 239, 255, 0.3) 0%,
        #eff7ff 100%
      );

      &:hover {
        opacity: 1;
        background-image: linear-gradient(270deg, #f0f8ff 0%, #deefff 100%);
        box-shadow: 0 2px 5px 2px rgba(223, 232, 241, 0.43);
        // width: 256px;
      }

      .rs-name {
        font-size: 14px;
        color: #333333;
        letter-spacing: -0.2px;
        margin-bottom: 10px;
      }

      .rs-label {
        width: 230px;
        height: 22px;
        overflow: hidden;

        .rs-label-item {
          float: left;
          background: rgba(255, 255, 255, 0.5);
          border: 1px solid $colorStyle;
          border-radius: 11px;
          font-size: 12px;
          color: $colorStyle;
          letter-spacing: 0.5px;
          height: 22px;
          line-height: 22px;
          max-width: 210px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding: 0 10px;
          margin-right: 10px;
        }
      }
    }
  }
}

.vertical-center-modal {
  /deep/ .h-modal-wrap {
    display: flex;
    align-items: center;
  }

  /deep/ .h-modal-content {
    width: 392px !important;
  }
}

.extra-info-styles {
  padding-left: 17px;
  padding-right: 17px;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  /deep/ p {
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 10px;
    color: #333333;
  }
}

.msg-extra-header-span {
  margin-left: 6px;
  font-family: PingFangSC-Medium;
  font-size: 20px;
  color: #333333;
  letter-spacing: 0;
  text-align: center;
  font-weight: 700;
}

.msg-extra-footer {
  text-align: center;

  /deep/ .h-btn-info {
    width: 160px;
    height: 40px;
    background-color: #3060ff;
    font-size: 14px;
  }
}

.buy-btn {
  background: $colorStyle;
  width: 120px;
  height: 40px;
  line-height: 40px;
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0.33px;
  text-align: center;
  cursor: pointer;
  margin-right: 16px;
}

.service-label {
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
}

.service-label0 {
  height: 20px;
  line-height: 20px;
  padding: 0 13px;
  background: #ffe9ea;
  border: 1px solid #ff595e;
  border-radius: 11px;
  color: #ff595e;
}

.service-label1 {
  height: 20px;
  line-height: 20px;
  padding: 0 13px;
  background: #e8f2ff;
  border: 1px solid $colorStyle;
  border-radius: 11px;
  color: $colorStyle;
  display: inline-block;
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
<style lang="scss">
.confirmMsgBox {
  .h-modal-body .h-modal-confirm-head-icon {
    display: none;
  }
  .h-modal-body .h-modal-confirm-head-title {
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/serviceDetail.vue